import { TransferenciaListModel } from "model/api/gestao/transferencia/transferencia-list-model"
import { useDefaultCardStyles } from "../components/default-card/default-card-styles";
import { useStyles } from "./card-transferencia-styles";
import { StatusTransferenciaMock } from "data/mocks/status-transacao-mock";
import { DefaultCard } from "../components";
import { Grid, Tooltip, Typography } from "@material-ui/core";
import classNames from "classnames";
import { toDateString } from "utils/to-date";
import { toCurrency } from "utils/toCurrency";
import { formatarCPFCNPJ } from "utils/cpfcnpj-format";
interface CardTransferenciaProps {
    model: TransferenciaListModel
    onClick: (model: TransferenciaListModel) => void;
}

export const CardTransferencia = ({ model, onClick }: CardTransferenciaProps) => {
    const classes = useDefaultCardStyles({});

    const cardClasses = useStyles({
        status: model.status
    });

    const descricao = StatusTransferenciaMock.filter(
        (x) => {
            return x.Key === model.status
        },
    )[0]?.Value || '';

    return (
        <>
            <DefaultCard onClick={() => {
                onClick(model)
            }}>
                <Tooltip arrow title={descricao} placement="right">
                    <div
                        className={classNames(classes.tagStatus, cardClasses.tagColor)}
                    ></div>
                </Tooltip>
                <div className={`${classes.cardContent} ${cardClasses.container}`}>
                    <Grid container spacing={2} className={cardClasses.naoQuebraLinha}>
                        <Grid item xs={6} md={true}>
                            <Typography color="textSecondary" variant="caption">
                                CPF/CNPJ: {formatarCPFCNPJ(model.codigoFornecedor)}
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {model.nomeFornecedor}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <Typography color="textSecondary" variant="caption">
                                Tipo Pagto
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {model.tipoPagamento}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <Typography color="textSecondary" variant="caption">
                                Banco
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {model.bancoDestino}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <Typography color="textSecondary" variant="caption">
                                Agência
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {model.digitoAgenciaDestino ? `${model.agenciaDestino}-${model.digitoAgenciaDestino}` : model.agenciaDestino}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <Typography color="textSecondary" variant="caption">
                                Conta
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {model.contaCorrenteDestino}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <Typography color="textSecondary" variant="caption">
                                Data Pagto
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {toDateString(model.dataPagamento, 'DD/MM/yyyy')}
                            </Typography>
                        </Grid>
                        <Grid item xs={6} md={1}>
                            <Typography color="textSecondary" variant="caption">
                                Valor
                            </Typography>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                <b>{toCurrency(model.valorPagamento)}</b>
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
                {/* <Box className={cardClasses.iconsContainer}>
                    <Tooltip title='Imprimir'>
                        <Box>
                            <ButtonIcon
                                icon={<ImpressoraIcon tipo='BUTTON' />}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onClickImprimir(model.id)
                                }}
                            />
                        </Box>
                    </Tooltip>
                </Box> */}
            </DefaultCard>
        </>
    )

}